import {
  TaggedEnum,
  describeTaggedEnumType,
  tagEnum,
} from '@suntex.core/types';

import { buildStaticContext } from '../utils';

const $ = 'RankingLevel';

export const RankingLevel = {
  Diamond: tagEnum($, 1),
  Platinum: tagEnum($, 101),
  Gold: tagEnum($, 201),
  Silver: tagEnum($, 301),
  Bronze: tagEnum($, 401),
} as const;

export type RankingLevel = TaggedEnum<typeof $>;

export const $RankingLevel = buildStaticContext(
  describeTaggedEnumType($, RankingLevel),
);
